// Comprehensive list of countries with flags and phone codes
export const countries = [
  // South America (prioritized)
  { code: '+591', name: 'Bolivia', flag: '🇧🇴', iso: 'bo' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷', iso: 'ar' },
  { code: '+55', name: 'Brasil', flag: '🇧🇷', iso: 'br' },
  { code: '+56', name: 'Chile', flag: '🇨🇱', iso: 'cl' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴', iso: 'co' },
  { code: '+593', name: 'Ecuador', flag: '🇪🇨', iso: 'ec' },
  { code: '+595', name: 'Paraguay', flag: '🇵🇾', iso: 'py' },
  { code: '+51', name: 'Perú', flag: '🇵🇪', iso: 'pe' },
  { code: '+598', name: 'Uruguay', flag: '🇺🇾', iso: 'uy' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪', iso: 've' },
  { code: '+592', name: 'Guyana', flag: '🇬🇾', iso: 'gy' },
  { code: '+597', name: 'Surinam', flag: '🇸🇷', iso: 'sr' },
  { code: '+594', name: 'Guayana Francesa', flag: '🇬🇫', iso: 'gf' },

  // North America
  { code: '+1', name: 'Estados Unidos', flag: '🇺🇸', iso: 'us' },
  { code: '+1', name: 'Canadá', flag: '🇨🇦', iso: 'ca' },
  { code: '+52', name: 'México', flag: '🇲🇽', iso: 'mx' },

  // Central America & Caribbean
  { code: '+501', name: 'Belice', flag: '🇧🇿', iso: 'bz' },
  { code: '+502', name: 'Guatemala', flag: '🇬🇹', iso: 'gt' },
  { code: '+503', name: 'El Salvador', flag: '🇸🇻', iso: 'sv' },
  { code: '+504', name: 'Honduras', flag: '🇭🇳', iso: 'hn' },
  { code: '+505', name: 'Nicaragua', flag: '🇳🇮', iso: 'ni' },
  { code: '+506', name: 'Costa Rica', flag: '🇨🇷', iso: 'cr' },
  { code: '+507', name: 'Panamá', flag: '🇵🇦', iso: 'pa' },
  { code: '+1', name: 'República Dominicana', flag: '🇩🇴', iso: 'do' },
  { code: '+509', name: 'Haití', flag: '🇭🇹', iso: 'ht' },
  { code: '+1', name: 'Jamaica', flag: '🇯🇲', iso: 'jm' },
  { code: '+53', name: 'Cuba', flag: '🇨🇺', iso: 'cu' },
  { code: '+1', name: 'Puerto Rico', flag: '🇵🇷', iso: 'pr' },

  // Europe
  { code: '+34', name: 'España', flag: '🇪🇸', iso: 'es' },
  { code: '+33', name: 'Francia', flag: '🇫🇷', iso: 'fr' },
  { code: '+49', name: 'Alemania', flag: '🇩🇪', iso: 'de' },
  { code: '+39', name: 'Italia', flag: '🇮🇹', iso: 'it' },
  { code: '+44', name: 'Reino Unido', flag: '🇬🇧', iso: 'gb' },
  { code: '+351', name: 'Portugal', flag: '🇵🇹', iso: 'pt' },
  { code: '+31', name: 'Países Bajos', flag: '🇳🇱', iso: 'nl' },
  { code: '+41', name: 'Suiza', flag: '🇨🇭', iso: 'ch' },
  { code: '+43', name: 'Austria', flag: '🇦🇹', iso: 'at' },
  { code: '+32', name: 'Bélgica', flag: '🇧🇪', iso: 'be' },
  { code: '+45', name: 'Dinamarca', flag: '🇩🇰', iso: 'dk' },
  { code: '+358', name: 'Finlandia', flag: '🇫🇮', iso: 'fi' },
  { code: '+47', name: 'Noruega', flag: '🇳🇴', iso: 'no' },
  { code: '+46', name: 'Suecia', flag: '🇸🇪', iso: 'se' },
  { code: '+354', name: 'Islandia', flag: '🇮🇸', iso: 'is' },
  { code: '+353', name: 'Irlanda', flag: '🇮🇪', iso: 'ie' },
  { code: '+48', name: 'Polonia', flag: '🇵🇱', iso: 'pl' },
  { code: '+420', name: 'República Checa', flag: '🇨🇿', iso: 'cz' },
  { code: '+421', name: 'Eslovaquia', flag: '🇸🇰', iso: 'sk' },
  { code: '+36', name: 'Hungría', flag: '🇭🇺', iso: 'hu' },
  { code: '+40', name: 'Rumania', flag: '🇷🇴', iso: 'ro' },
  { code: '+359', name: 'Bulgaria', flag: '🇧🇬', iso: 'bg' },
  { code: '+385', name: 'Croacia', flag: '🇭🇷', iso: 'hr' },
  { code: '+386', name: 'Eslovenia', flag: '🇸🇮', iso: 'si' },
  { code: '+387', name: 'Bosnia y Herzegovina', flag: '🇧🇦', iso: 'ba' },
  { code: '+381', name: 'Serbia', flag: '🇷🇸', iso: 'rs' },
  { code: '+382', name: 'Montenegro', flag: '🇲🇪', iso: 'me' },
  { code: '+383', name: 'Kosovo', flag: '🇽🇰', iso: 'xk' },
  { code: '+389', name: 'Macedonia del Norte', flag: '🇲🇰', iso: 'mk' },
  { code: '+355', name: 'Albania', flag: '🇦🇱', iso: 'al' },
  { code: '+30', name: 'Grecia', flag: '🇬🇷', iso: 'gr' },
  { code: '+90', name: 'Turquía', flag: '🇹🇷', iso: 'tr' },
  { code: '+7', name: 'Rusia', flag: '🇷🇺', iso: 'ru' },
  { code: '+380', name: 'Ucrania', flag: '🇺🇦', iso: 'ua' },
  { code: '+375', name: 'Bielorrusia', flag: '🇧🇾', iso: 'by' },
  { code: '+370', name: 'Lituania', flag: '🇱🇹', iso: 'lt' },
  { code: '+371', name: 'Letonia', flag: '🇱🇻', iso: 'lv' },
  { code: '+372', name: 'Estonia', flag: '🇪🇪', iso: 'ee' },
  { code: '+373', name: 'Moldavia', flag: '🇲🇩', iso: 'md' },

  // Asia
  { code: '+86', name: 'China', flag: '🇨🇳', iso: 'cn' },
  { code: '+91', name: 'India', flag: '🇮🇳', iso: 'in' },
  { code: '+81', name: 'Japón', flag: '🇯🇵', iso: 'jp' },
  { code: '+82', name: 'Corea del Sur', flag: '🇰🇷', iso: 'kr' },
  { code: '+850', name: 'Corea del Norte', flag: '🇰🇵', iso: 'kp' },
  { code: '+66', name: 'Tailandia', flag: '🇹🇭', iso: 'th' },
  { code: '+84', name: 'Vietnam', flag: '🇻🇳', iso: 'vn' },
  { code: '+62', name: 'Indonesia', flag: '🇮🇩', iso: 'id' },
  { code: '+60', name: 'Malasia', flag: '🇲🇾', iso: 'my' },
  { code: '+65', name: 'Singapur', flag: '🇸🇬', iso: 'sg' },
  { code: '+63', name: 'Filipinas', flag: '🇵🇭', iso: 'ph' },
  { code: '+92', name: 'Pakistán', flag: '🇵🇰', iso: 'pk' },
  { code: '+880', name: 'Bangladesh', flag: '🇧🇩', iso: 'bd' },
  { code: '+94', name: 'Sri Lanka', flag: '🇱🇰', iso: 'lk' },
  { code: '+95', name: 'Myanmar', flag: '🇲🇲', iso: 'mm' },
  { code: '+855', name: 'Camboya', flag: '🇰🇭', iso: 'kh' },
  { code: '+856', name: 'Laos', flag: '🇱🇦', iso: 'la' },
  { code: '+977', name: 'Nepal', flag: '🇳🇵', iso: 'np' },
  { code: '+975', name: 'Bután', flag: '🇧🇹', iso: 'bt' },
  { code: '+998', name: 'Uzbekistán', flag: '🇺🇿', iso: 'uz' },
  { code: '+996', name: 'Kirguistán', flag: '🇰🇬', iso: 'kg' },
  { code: '+992', name: 'Tayikistán', flag: '🇹🇯', iso: 'tj' },
  { code: '+993', name: 'Turkmenistán', flag: '🇹🇲', iso: 'tm' },
  { code: '+7', name: 'Kazajistán', flag: '🇰🇿', iso: 'kz' },
  { code: '+994', name: 'Azerbaiyán', flag: '🇦🇿', iso: 'az' },
  { code: '+374', name: 'Armenia', flag: '🇦🇲', iso: 'am' },
  { code: '+995', name: 'Georgia', flag: '🇬🇪', iso: 'ge' },

  // Middle East
  { code: '+98', name: 'Irán', flag: '🇮🇷', iso: 'ir' },
  { code: '+964', name: 'Irak', flag: '🇮🇶', iso: 'iq' },
  { code: '+966', name: 'Arabia Saudí', flag: '🇸🇦', iso: 'sa' },
  { code: '+971', name: 'Emiratos Árabes Unidos', flag: '🇦🇪', iso: 'ae' },
  { code: '+974', name: 'Qatar', flag: '🇶🇦', iso: 'qa' },
  { code: '+973', name: 'Bahrein', flag: '🇧🇭', iso: 'bh' },
  { code: '+965', name: 'Kuwait', flag: '🇰🇼', iso: 'kw' },
  { code: '+968', name: 'Omán', flag: '🇴🇲', iso: 'om' },
  { code: '+967', name: 'Yemen', flag: '🇾🇪', iso: 'ye' },
  { code: '+962', name: 'Jordania', flag: '🇯🇴', iso: 'jo' },
  { code: '+961', name: 'Líbano', flag: '🇱🇧', iso: 'lb' },
  { code: '+963', name: 'Siria', flag: '🇸🇾', iso: 'sy' },
  { code: '+972', name: 'Israel', flag: '🇮🇱', iso: 'il' },
  { code: '+970', name: 'Palestina', flag: '🇵🇸', iso: 'ps' },

  // Africa
  { code: '+27', name: 'Sudáfrica', flag: '🇿🇦', iso: 'za' },
  { code: '+20', name: 'Egipto', flag: '🇪🇬', iso: 'eg' },
  { code: '+234', name: 'Nigeria', flag: '🇳🇬', iso: 'ng' },
  { code: '+254', name: 'Kenia', flag: '🇰🇪', iso: 'ke' },
  { code: '+251', name: 'Etiopía', flag: '🇪🇹', iso: 'et' },
  { code: '+233', name: 'Ghana', flag: '🇬🇭', iso: 'gh' },
  { code: '+255', name: 'Tanzania', flag: '🇹🇿', iso: 'tz' },
  { code: '+256', name: 'Uganda', flag: '🇺🇬', iso: 'ug' },
  { code: '+212', name: 'Marruecos', flag: '🇲🇦', iso: 'ma' },
  { code: '+213', name: 'Argelia', flag: '🇩🇿', iso: 'dz' },
  { code: '+216', name: 'Túnez', flag: '🇹🇳', iso: 'tn' },
  { code: '+218', name: 'Libia', flag: '🇱🇾', iso: 'ly' },
  { code: '+249', name: 'Sudán', flag: '🇸🇩', iso: 'sd' },
  { code: '+211', name: 'Sudán del Sur', flag: '🇸🇸', iso: 'ss' },
  { code: '+221', name: 'Senegal', flag: '🇸🇳', iso: 'sn' },
  { code: '+225', name: 'Costa de Marfil', flag: '🇨🇮', iso: 'ci' },
  { code: '+226', name: 'Burkina Faso', flag: '🇧🇫', iso: 'bf' },
  { code: '+223', name: 'Malí', flag: '🇲🇱', iso: 'ml' },
  { code: '+227', name: 'Níger', flag: '🇳🇪', iso: 'ne' },
  { code: '+235', name: 'Chad', flag: '🇹🇩', iso: 'td' },
  { code: '+236', name: 'República Centroafricana', flag: '🇨🇫', iso: 'cf' },
  { code: '+237', name: 'Camerún', flag: '🇨🇲', iso: 'cm' },
  { code: '+240', name: 'Guinea Ecuatorial', flag: '🇬🇶', iso: 'gq' },
  { code: '+241', name: 'Gabón', flag: '🇬🇦', iso: 'ga' },
  { code: '+242', name: 'República del Congo', flag: '🇨🇬', iso: 'cg' },
  { code: '+243', name: 'República Democrática del Congo', flag: '🇨🇩', iso: 'cd' },
  { code: '+244', name: 'Angola', flag: '🇦🇴', iso: 'ao' },
  { code: '+260', name: 'Zambia', flag: '🇿🇲', iso: 'zm' },
  { code: '+263', name: 'Zimbabue', flag: '🇿🇼', iso: 'zw' },
  { code: '+265', name: 'Malawi', flag: '🇲🇼', iso: 'mw' },
  { code: '+258', name: 'Mozambique', flag: '🇲🇿', iso: 'mz' },
  { code: '+264', name: 'Namibia', flag: '🇳🇦', iso: 'na' },
  { code: '+267', name: 'Botsuana', flag: '🇧🇼', iso: 'bw' },
  { code: '+268', name: 'Esuatini', flag: '🇸🇿', iso: 'sz' },
  { code: '+266', name: 'Lesoto', flag: '🇱🇸', iso: 'ls' },
  { code: '+261', name: 'Madagascar', flag: '🇲🇬', iso: 'mg' },
  { code: '+230', name: 'Mauricio', flag: '🇲🇺', iso: 'mu' },
  { code: '+248', name: 'Seychelles', flag: '🇸🇨', iso: 'sc' },

  // Oceania
  { code: '+61', name: 'Australia', flag: '🇦🇺', iso: 'au' },
  { code: '+64', name: 'Nueva Zelanda', flag: '🇳🇿', iso: 'nz' },
  { code: '+679', name: 'Fiyi', flag: '🇫🇯', iso: 'fj' },
  { code: '+676', name: 'Tonga', flag: '🇹🇴', iso: 'to' },
  { code: '+685', name: 'Samoa', flag: '🇼🇸', iso: 'ws' },
  { code: '+686', name: 'Kiribati', flag: '🇰🇮', iso: 'ki' },
  { code: '+687', name: 'Nueva Caledonia', flag: '🇳🇨', iso: 'nc' },
  { code: '+689', name: 'Polinesia Francesa', flag: '🇵🇫', iso: 'pf' },
  { code: '+675', name: 'Papúa Nueva Guinea', flag: '🇵🇬', iso: 'pg' },
  { code: '+677', name: 'Islas Salomón', flag: '🇸🇧', iso: 'sb' },
  { code: '+678', name: 'Vanuatu', flag: '🇻🇺', iso: 'vu' },
  { code: '+680', name: 'Palau', flag: '🇵🇼', iso: 'pw' },
  { code: '+691', name: 'Micronesia', flag: '🇫🇲', iso: 'fm' },
  { code: '+692', name: 'Islas Marshall', flag: '🇲🇭', iso: 'mh' },
  { code: '+683', name: 'Niue', flag: '🇳🇺', iso: 'nu' },
  { code: '+688', name: 'Tuvalu', flag: '🇹🇻', iso: 'tv' },
  { code: '+690', name: 'Tokelau', flag: '🇹🇰', iso: 'tk' }
];

// Helper function to get country by code
export const getCountryByCode = (code) => {
  return countries.find(country => country.code === code);
};

// Helper function to get all country codes
export const getCountryCodes = () => {
  return countries.map(country => country.code);
};

// Preferred countries for the top of the list (South America + major countries)
export const preferredCountries = [
  '+591', '+54', '+55', '+56', '+57', '+593', '+595', '+51', '+598', '+58',
  '+1', '+52', '+34', '+33', '+49', '+39', '+44', '+351'
];